import React, { useState } from 'react';
import { MdDelete } from "react-icons/md";
import { FiAlertTriangle } from "react-icons/fi";
import Modal from 'react-bootstrap/Modal';

export default function Reservation() {
  

    const [fileName, setFileName] = useState('Choose a file');
    const [fileUrl, setFileUrl] = useState(null);

    const [show, setShow] = useState(false);
    const [show2, setShow2] = useState(false);
    const [showSM, setShowSM] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            setFileUrl(URL.createObjectURL(file));
        } else {
            setFileName('Choose a file');
            setFileUrl(null);
        }
    };

    return (
        <>
            <div className='scroll-box'>
                <div className='container-fluid g-0 mt-3'>
                    <div className='row d-flex justify-content-between align-items-center mb-2 g-0 py-2'>
                        
                        <div className='col-4'>
                            <input
                                type="text"
                                placeholder="Search"
                                className="form-control form-control-sm"
                            />
                        </div>
                        <div onClick={() => setShow(true)} className='col-2 d-flex justify-content-center align-items-center p-2 rounded-1' style={{ backgroundColor: "#000", fontWeight: 400, color: "#fff", cursor: "pointer" }}>
                            + Add
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-12 m-auto">
                            <div className='card-list-box-sr card p-2 border-0'>
                                <div className="table-responsive">
                                    <table className="table table-striped table-bordered table-sm align-middle ">
                                        <thead className="table-dark">
                                            <tr>
                                                <th>Name</th>
                                                <th>Table No.</th>
                                                <th>Date</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>Banner1</td>
                                                <td>21</td>
                                                <td>10/08/2024</td>
                                                <td>
                                                    <div className='d-flex justify-content-center gap-2'>
                                                        <MdDelete onClick={() => setShowSM(true)} style={{ cursor: "pointer", color: "#E74C3C" }} />
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                {/* Add Modal */}
                                <Modal show={show} onHide={() => setShow(false)} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Banner</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className='container-fluid'>
                                            <form>
                                                <div className='row'>
                                                    <div className='col-lg-4 col-md-6 col-sm-12'>
                                                        <label className='form-label' style={{ fontSize: "13px", fontWeight: 600 }}>Banner Name</label>
                                                        <input className='form-control' type='text' placeholder="Banner Name" required />
                                                    </div>
                                                    <div className='col-lg-4 col-md-6 col-sm-12'>
                                                        <label className='form-label' style={{ fontSize: "13px", fontWeight: 600 }}>Choose a File</label>
                                                        <input className="form-control" type="file" accept=".jpg,.jpeg,.png,.pdf,.txt" onChange={handleFileChange} />
                                                        <small>{fileName}</small>
                                                        {fileUrl && <img src={fileUrl} alt="Selected" className="img-fluid mt-2" />}
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className='col-2 m-auto'>
                                                        <button type='submit' className='btn btn-dark w-100'>Save</button>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </Modal.Body>
                                </Modal>

                                {/* Edit Modal */}
                                <Modal show={show2} onHide={() => setShow2(false)} size="lg">
                                    <Modal.Header closeButton>
                                        <Modal.Title>Edit</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>
                                        <div className='container-fluid'>
                                            <div className='row'>
                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                    <label className='form-label' style={{ fontSize: "13px", fontWeight: 600 }}>Banner Name</label>
                                                    <input className='form-control' type='text' placeholder="Banner Name" required />
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                    <label className='form-label' style={{ fontSize: "13px", fontWeight: 600 }}>Banner Rs.</label>
                                                    <input className='form-control' type='text' placeholder="Banner Rs." required />
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12'>
                                                    <label className='form-label' style={{ fontSize: "13px", fontWeight: 600 }}>Image</label>
                                                    {fileUrl && <img src={fileUrl} alt="Selected" className="img-fluid" />}
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className='col-2 m-auto'>
                                                    <button className='btn btn-dark w-100'>Save</button>
                                                </div>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            <Modal size="sm" show={showSM} onHide={() => setShowSM(false)}>
                <Modal.Header closeButton>
                    <Modal.Title><FiAlertTriangle style={{ color: "orangered" }} /></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center" style={{ fontSize: "16px", color: '#1f5156', fontWeight: 500 }}>
                        Are you sure want to Delete ??
                    </div>
                    <div className='d-flex justify-content-between mt-3'>
                        <div onClick={() => setShowSM(false)} className='btn btn-success w-100 me-2'>Yes</div>
                        <div onClick={() => setShowSM(false)} className='btn btn-danger w-100'>No</div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
